import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .subtitle': {
        color: '#9B9B9B',
        fontSize: '12px',
    },
    '& .title': {
        color: '#005E96',
        fontSize: '16px',
    },
    '& .crtTitle': {
        color: '#005E96',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    '& .tableWapper': {
        width: '100%',
        overflowX: 'auto',
        '& .table': {
            minWidth: '650px',
        }
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
});